<template>
  <div class="main-modular main-modular-screen">
    <div class="main-name">
      {{ labelName }}
    </div>
    <div
      :class="{
        'main-lable': true,
        nowrapStyle: blockStyle ? blockStyle : false,
      }"
      style="padding: 0"
    >
      <div
        :class="{
          'main-card': true,
          activeMainCard: itemChild.check,
        }"
        v-for="itemChild in mainLabelArray"
        :key="itemChild.id"
        @click="activeSelectedLabel(itemChild)"
      >
        {{ itemChild.label }}
      </div>
    </div>
    <div class="more" v-if="block">
      <div v-if="blockStyle" @click="moreFun()">
        展开
        <div style="margin-left: 5px" class="el-icon-arrow-down"></div>
      </div>
      <div class="more" v-else @click="moreFun()">
        收起<i style="margin-left: 5px" class="el-icon-arrow-up"></i>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  props: {
    mainLabelProps: {
      type: Array,
      default: () => [],
    },
    labelName: {
      type: String,
      default: "",
    },
    blockStyleProps: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mainLabelArray: [],
      blockStyle: true,
      block: false,
    };
  },
  created() {},
  methods: {
    // 搜索点击
    activeSelectedLabel(itemValue) {
      this.mainLabelArray = this.mainLabelArray.filter((item) => {
        if (item.id == itemValue.id) {
          item.check = true;
          if (item.check) {
            if (this.labelName == "适用地区：") {
              this.$emit("saveMatter", itemValue.regionCode);
            } else {
              this.$emit("saveMatter", itemValue.value);
            }
          } else {
            this.$emit("saveMatter", "");
          }
        } else {
          item.check = false;
        }
        return item;
      });
    },
    moreFun() {
      // console.log(style)
      this.blockStyle == true
        ? (this.blockStyle = false)
        : (this.blockStyle = true);
    },
  },
  watch: {
    mainLabelProps: {
      handler(val) {
        this.mainLabelArray = val;
      },
      deep: true,
      immediate: true,
    },
    labelName: {
      handler(val) {
        if ($(window).width() < 767) {
          this.block = true;
        } else {
          if (val != "企业规模：") {
            this.block = true;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    blockStyleProps: {
      handler(val) {
        if (!val) {
          this.blockStyle = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="less" scoped>
.more {
  float: left;
  margin: 5px 0;
  font-size: 14px;
  color: #1287f9;
}
.main-modular::after {
  content: "\20";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  overflow: hidden;
}
.activeMainCard {
  color: #fff !important;
  background: #1287f9;
}
.main-modular {
  width: 100%;
  border: none;
  // border-bottom: 1px solid #dbdbdb;
  box-sizing: border-box;
  padding: 10px 0px;
}

.main-modular:last-child {
  border-bottom: none;
}
.main-name {
  float: left;
  width: 10%;
  text-align: center;
  padding: 5px 5px;
  color: #666;
  font-size: 14px;
  // cursor: pointer;
}
.main-lable {
  width: 80%;
  float: left;
}
.nowrapStyle {
  overflow: hidden;
  // white-space:nowrap;
  height: 30px;
}
.main-modular-screen {
  margin-bottom: 0px;
}

.main-card {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  color: #888;
  font-size: 14px;
  box-sizing: border-box;
  padding: 5px 20px;
  border-radius: 3px;
}
@media screen and (max-width: 1200px) {
}
@media screen and (max-width: 1024px) {
  .main-name {
    width: 10%;
    font-size: 14px;
  }
  .main-lable {
    width: 80%;
  }
  .main-card {
    font-size: 14px;
  }
}
@media screen and (max-width: 767px) {
  .main-name {
    width: 21%;
    font-size: 12px;
  }
  .main-lable {
    width: 60%;
  }
  .main-card {
    padding: 3px 5px;
    font-size: 12px;
  }
  .main-modular {
    padding: 5px 0;
  }
  .more {
    font-size: 12px;
  }
}
</style>
